'use client'

import { memo } from 'react'

import type { Action } from '../types'
import { ExternalIcon } from '@components/Layout/NavLink'
import { Button, type ButtonProps } from '@fp/ui-kit'

interface ActionButtonProps {
  action: Action
  onClick: () => void
  variant?: ButtonProps['variant']
  size?: ButtonProps['size']
}

export const ActionButton = memo<ActionButtonProps>(({ action, onClick, variant = 'default', size = 'sm' }) => (
  <Button variant={variant} size={size} onClick={onClick}>
    {action.name}
    {action.external && <ExternalIcon />}
  </Button>
))

ActionButton.displayName = 'ActionButton'
